import React from 'react'
import { Box } from '@mui/material'
import { menuNameAlternates } from '../../utils/menuName'

/**
 * The AI-translated names the restaurant owner chose to publish, rendered in
 * brackets beside the English name:
 *
 *   Chicken Biryani (చికెన్ బిర్యానీ) (鸡肉比尔亚尼)
 *
 * Renders nothing at all when the restaurant has no menu languages configured,
 * when display is turned off, or when this particular item has not been
 * translated yet — so menus look exactly as they did before the owner opted in.
 *
 * `block` stacks the translations on their own line instead of trailing the
 * name inline; used in narrow chips and sidebar rows where an inline run would
 * push the layout wide.
 */
export default function AltNames({ alt1, alt2, displayMode, block = false, sx }) {
  const alternates = menuNameAlternates(alt1, alt2, displayMode)
  if (!alternates.length) return null

  return (
    <Box
      component="span"
      sx={{
        display: block ? 'block' : 'inline',
        ml: block ? 0 : 0.6,
        fontSize: '0.86em',
        fontWeight: 400,
        color: '#64748b',
        lineHeight: 1.35,
        ...sx,
      }}
    >
      {alternates.map((a) => `(${a})`).join(' ')}
    </Box>
  )
}
